import { useUserData } from '@/services/user';
import { AvatarProps as ChakraAvatarProps } from '@chakra-ui/react';
import { getPartnerName } from '@common/react/user';
import styleguide from '@common/styleguide';
import { FC } from 'react';
import Avatar from './Avatar';

const PartnerAvatar: FC<ChakraAvatarProps> = (props) => {
    const { partnerInfo } = useUserData();
    const partnerName = getPartnerName(partnerInfo);

    return partnerInfo?.avatar ? (
        <Avatar avatar={partnerInfo?.avatar} {...props} />
    ) : (
        <Avatar
            // avoid showing "Yo" (show generic user icon instead)
            firstName={partnerName === 'Your partner' ? undefined : partnerName}
            bg={styleguide.colors.orangeBright}
            {...props}
        />
    );
};

export default PartnerAvatar;
